import React, { useEffect, useRef, useState } from 'react'
import { FilterValueOption } from '../../GenericComponents/filterTypes'

const FilterValueDropdown = (props: { selectFilterValueOptionFn: Function, selectedDropdownOptn: string }) => {
    const [isOpenFilterOptions, setIsOpenFilterOptions] = useState<boolean>(false)
    const [filterValueOption, setFilterValueOption] = useState<FilterValueOption>('INCLUDE_ANY')
    const filterDropdownRef = useRef<HTMLDivElement | null>(null)
    const toggleRef = useRef<HTMLAnchorElement | null>(null);
    const selectFilterValueOption = (
        action: 'INCLUDE_ANY' | 'EXCLUDE_ANY' | 'INCLUDE_ALL' | 'EXCLUDE_ALL'
    ) => {
        setFilterValueOption(action)
        props.selectFilterValueOptionFn(action)
        setIsOpenFilterOptions(false)
    }

    useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target as Node) && 
                toggleRef.current && !toggleRef.current.contains(event.target as Node)) {
                    setIsOpenFilterOptions(false)
                }
            }
            document.addEventListener('mousedown', handleClickOutside)
            return () => {
                document.removeEventListener('mousedown', handleClickOutside)
            }
        }, [])

    return (
        <span id="vu_popup_filter_options" className="vu-popup-filter-options">
            <div id="vu_filtervalue_option_wrapper" className="hl-ui-menu-wrapper">
                <a
                    ref={toggleRef}
                    onClick={() => setIsOpenFilterOptions(prev => !prev)}
                    id="vu_filtervalue_option_label"
                    href="javascript:void(0);"
                    className="hl-ui-selector"
                >
                    <span className="hl-ui-selector-label">{
                        filterValueOption === "INCLUDE_ANY" ? "Include ANY selected values" :
                        filterValueOption === "INCLUDE_ALL" ? "Include ALL selected values" :
                        filterValueOption === "EXCLUDE_ANY" ? "Exclude ANY selected values" :
                        filterValueOption === "EXCLUDE_ALL" && "Exclude ALL selected values"
                    }
                    </span>
                    <span className="hl-ui-selector-image">▼</span>
                </a>
                {/* here.. */}
                {isOpenFilterOptions && (
                    <div ref={filterDropdownRef} className="hl-ui-selector-menu-wrapper">
                        <div className="hl-ui-menu">
                            <ul id="vu_filtervalue_option" className="hl-ui-menu-list">
                                <li
                                    id="vu_filtervalue_option_include_any"
                                    className="hl-ui-menu-item"
                                >
                                    <a
                                        href="javascript:void(0);"
                                        className="hl-item-anchor"
                                        onClick={() => selectFilterValueOption('INCLUDE_ANY')}
                                    >
                                        {filterValueOption === 'INCLUDE_ANY' && (
                                            <span className="hl-item-icon">✔</span>
                                        )}
                                        <span className="hl-item-label">
                                            Include ANY selected values
                                        </span>
                                    </a>
                                </li>
                                <li
                                    id="vu_filtervalue_option_exclude_any"
                                    className="hl-ui-menu-item"
                                >
                                    <a
                                        href="javascript:void(0);"
                                        className="hl-item-anchor"
                                        onClick={() => selectFilterValueOption('EXCLUDE_ANY')}
                                    >
                                        {filterValueOption === 'EXCLUDE_ANY' && (
                                            <span className="hl-item-icon">✔</span>
                                        )}
                                        <span className="hl-item-label">
                                            Exclude ANY selected values
                                        </span>
                                    </a>
                                </li>
                                <li
                                    id="vu_filtervalue_option_include_all"
                                    className="hl-ui-menu-item"
                                >
                                    <a
                                        href="javascript:void(0);"
                                        className="hl-item-anchor"
                                        onClick={() => selectFilterValueOption('INCLUDE_ALL')}
                                    >
                                        {filterValueOption === 'INCLUDE_ALL' && (
                                            <span className="hl-item-icon">✔</span>
                                        )}
                                        <span className="hl-item-label">
                                            Include ALL selected values
                                        </span>
                                    </a>
                                </li>
                                <li
                                    id="vu_filtervalue_option_exclude_all"
                                    className="hl-ui-menu-item"
                                >
                                    <a
                                        href="javascript:void(0);"
                                        className="hl-item-anchor"
                                        onClick={() => selectFilterValueOption('EXCLUDE_ALL')}
                                    >
                                        {filterValueOption === 'EXCLUDE_ALL' && (
                                            <span className="hl-item-icon">✔</span>
                                        )}
                                        <span className="hl-item-label">
                                            Exclude ALL selected values
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </span>
    )
}

export default FilterValueDropdown
